import React from 'react'
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {useTranslation} from 'react-i18next';

// Images
import loadingSpinner from '../../../assets/images/loading_spinner.gif';
import RowLayout from '../../Layouts/RowLayout';

function SMCTableLoadingRow({
    style
}) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <RowLayout center style={style}>
            <img alt="" src={loadingSpinner} className={classes.img} />
            {t('SMC_GEN_LOADING')}...
        </RowLayout>
    );
}

const useStyles = makeStyles({
    img: {
        verticalAlign: 'middle',
        height: '22px'
    }
})

SMCTableLoadingRow.propTypes = {
    style: PropTypes.object
}

export default SMCTableLoadingRow;